/**
 * Created by razial on 21.09.2026.
 */

const LivesFeast = function (mission, isNewMission) {
    this.mission = mission;

    if (isNewMission) {
        Map2dLocation.currentLocation.pixelsPlanner.restart();
    }
};
